import LogoSVG from '../LogoSVG/LogoSVG';
import Charli3Face from '../../Charli3Face/Charli3Face';
import './Hero.css';

function Hero() {
  return (
    <>
      <section id="hero" className="hero is-medium c_large-margin-top ">
      <div className="container is-widescreen is-relative">
        <div className="hero-body">
          <div className="columns">
            <div id="hero-copy" className="column">
            <LogoSVG />
            <p id="hero-title">Were you fast enough to catch charli3?</p>
            <p id="hero-subtitle">Our first CNFT Drop!</p>
            
            </div>
          </div>
          
          </div>
          <Charli3Face />
        </div>
      </section>
    </>
  );
}

export default Hero;